import { useEffect, useState, useMemo } from "react";
import { db } from "~/db/db";

const useAreasVendaVendedor = (formikRef) => {
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    const fetchAreas = async () => {
      const result = [];
      await db.areasVendaVendedor.each((a) => {
        result.push(a);
      });
      setAreas(result);
    };

    fetchAreas();
  }, []);

  const { escritoriosIds, equipesIds } = useMemo(() => {
    const escritoriosSet = new Set();
    const equipesSet = new Set();

    const trilhaId = formikRef?.current?.values?.trilhaId;
    areas.forEach((a) => {
      if (!a.ativo) return;

      if (trilhaId && a.trilhaId !== trilhaId) return;

      if (a.escritorioVendaId) escritoriosSet.add(a.escritorioVendaId);
      if (a.equipeVendaId) equipesSet.add(a.equipeVendaId);
    });

    return {
      escritoriosIds: Array.from(escritoriosSet),
      equipesIds: Array.from(equipesSet),
    };
  }, [areas, formikRef?.current?.values?.trilhaId]);

  return {
    areas,
    escritoriosIds,
    equipesIds,
  };
};

export default useAreasVendaVendedor;
